<template>
  <div class="bg-beige pt-5 pb-5 mt-2">
    <b-container fluid class="card-container mt-3 mb-5 mx-auto">
      <b-row>
        <b-col>
          <h2 class="mx-2">
            EXPLORE THE FUTURE OF TECHNOLOGY! ØREDEV OFFERS<br
              class="d-sm-none d-lg-block"
              aria-hidden="true"
            />
            100+ SESSIONS THROUGH OUR CURATED TRACKS:
          </h2>
        </b-col>
      </b-row>
    </b-container>
    <b-container
      fluid
      class="d-flex justify-content-center flex-wrap card-container"
    >
      <div
        v-for="(category, index) in tags_tagList"
        :key="index"
        class="category-card m-2 text-center"
        :style="{ backgroundColor: category.color }"
        :id="'card-tooltip-' + index"
        @click="/*handleRouting(category.tag)*/"
      >
        <div>
          <b-img
            class="card-img"
            :src="category.icon"
            alt=""
            aria-hidden="true"
          />
          <p
            class="card-text"
            v-html="category.name ? category.name : category.tag"
          ></p>
        </div>
        <b-tooltip :target="'card-tooltip-' + index" variant="dark">
          Speakers and sessions be will available soon
        </b-tooltip>
      </div>
    </b-container>
  </div>
</template>

<script>
import tags from "@/mixins/tags.js";

export default {
  mixins: [tags],
  methods: {
    handleRouting(tag) {
      this.$router.push("/line-up?tags=" + tag);
    },
  },
};
</script>

<style lang="scss" scoped>
@use "@/styles/variables.scss" as *;

h2 {
  font-size: 18px;
  @media (min-width: 577px) {
    font-size: 22px;
  }
  @media (min-width: 992px) {
    font-size: 24px;
  }
}
.card-container {
  width: 100%;
  @media (min-width: 361px) {
    width: 356px;
  }
  @media (min-width: 372px) {
    width: 372px;
  }
  @media (min-width: 577px) {
    width: 543px;
  }
  @media (min-width: 768px) {
    width: 678px;
  }
  @media (min-width: 992px) {
    width: 894px;
  }
}
.category-card {
  display: flex;
  justify-content: center; // vertical centering
  align-items: center; // horizontal centering

  cursor: not-allowed;
  border-radius: 15px;
  border: 2px solid $dark-brown;
  width: 100px;
  height: 100px;
  @media (min-width: 372px) {
    border: 3px solid $dark-brown;
    height: 155px;
    width: 155px;
  }
  @media (min-width: 768px) {
    border: 4px solid $dark-brown;
    height: 200px;
    width: 200px;
  }
  .card-img {
    width: 32px;
    @media (min-width: 768px) {
      width: 42px;
    }
  }
  .card-text {
    text-transform: uppercase;
    font-weight: 600;
    line-height: 1;
    font-size: 10px;
    margin-top: 4px;
    @media (min-width: 372px) {
      font-size: 14px;
      margin-top: 8px;
    }
    @media (min-width: 768px) {
      font-size: 16px;
      margin-top: 16px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/LandingPage/Gallery.vue